import { ChangeDetectorRef, Component, DestroyRef, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { IconV3Component } from '@gea/digital-ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AppInitService } from '../../services/shared-service/app-init.service';
import { environment } from 'src/app/core/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [CommonModule, IconV3Component, TranslateModule],

  styleUrl: './header.component.scss',
  standalone: true
})
export class HeaderComponent implements OnInit {


  currentShowDropdown: boolean = false;
  showSubSubMenu: boolean = false;
  userLogin: any;
  ControlSystemsName: string | null = '';
  ControlSystemsId: string | null = '';
  menuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];
  menuTop = 0;
  menuRight = 8;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly authService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly appAuthService: AuthService,
    private readonly appInitService: AppInitService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {


  }

  ngOnInit() {
    this.appInitService.controlSystemName$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(name => {
      this.ControlSystemsName = name;
      
      if (environment.name.includes('cloud')) {
        this.userLogin = sessionStorage.getItem('username');
      } else {
        try {
          const sessionData = localStorage.getItem('ceh-login-session');
          if (sessionData) {
            const parsedSession = JSON.parse(sessionData);
            this.userLogin = parsedSession.userName;
          }
        } catch (e) {
          console.error('Error parsing local session data', e);
        }
      }
    });
  }

  @ViewChild('profileMenu') profileMenu!: ElementRef;
  @ViewChild('profileButton') profileButton!: ElementRef;

  toggleDropdown() {
    this.currentShowDropdown = !this.currentShowDropdown;

    if (this.currentShowDropdown) {
      const rect = this.profileButton.nativeElement.getBoundingClientRect();
      this.menuTop = rect.bottom + 0;
      this.menuRight = -3;
    }
  }

  getLogoutLabel(translatedLabel: string): string {
    return !translatedLabel || translatedLabel === 'UI-LIB.HEADER.LOGOUT'
      ? 'Logout'
      : translatedLabel;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInsideMenu = this.profileMenu?.nativeElement.contains(event.target);
    const clickedButton = this.profileButton?.nativeElement.contains(event.target);

    if (!clickedInsideMenu && !clickedButton) {
      this.currentShowDropdown = false;
    }
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    if (environment.name.includes('cloud')) {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    } else {
      this.appAuthService.logout();
      this.router.navigate(['/'], { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }
    this.reloadContent();
  }

  private reloadContent(): void {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
}



